import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import InlineSvg from 'vue-inline-svg';
import { loadSeo } from './data/seo';
import './assets/scss/app.scss';

const appElement = document.getElementById('app');
const rawData = appElement ? appElement.getAttribute('data-data') : null;
let initialData = {};

try {
    initialData = rawData ? JSON.parse(rawData) : {};
} catch (error) {
    console.error('Error parsing initial data:', error);
}

// SEO-тексты нужны уже на первом переходе: по ним router решает, существует
// ли статья с таким slug. До монтирования на странице виден лоадер из
// templates/front-landing.html.twig.
loadSeo().then(() => {
    createApp(App, {
        initialData: initialData,
    })
        .use(router)
        .component('inline-svg', InlineSvg)
        .mount('#app');
});
